import { useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function AddBillerGroupModal
 * @param {STRING} billerGroupName - Sets the biller group name in the modal content description. 
 * @param {STRING} onClick - Allows us to apply an event handler on click.
 * @returns {React.Component}
 * @exported true
 * @description This is the modal that shows you add a new biller group.
 * @example
 * <AddBillerGroupModal />
 */
export default function AddBillerGroupModal(props) {
  const { close } = useBCMSModal();
  const data = props.data ?? {};
  const billerGroup = data.billerGroup ?? {};
  const billerGroupName = data.billerGroupName ?? "[billerName]";

  const onClick = () => {
    data.onAddGroupClick();
    close("AddBillerGroupModal");
  };

  return(
    <CustomModal id="AddBillerGroupModal" className="add-biller-group-modal large-icon-modal">
      <CustomModalContent className="flex-container flex-horizontal align-top">
        <div className="set-width">
          <SVGAsset id="CirclePlusSignIcon" className="circle-plus-icon left-icon" />
        </div>
        <div className="flex-width">
          <h4 className="modal-title"><b>Add biller group</b></h4>
          <p className="sub-text">Are you sure you want to add <b>{ billerGroupName }</b>?</p>
        </div>
      </CustomModalContent>
      <CustomModalFooter className="form-button-container">
        <ModalCloseButton text="Cancel" id="AddBillerGroupModal" />
        <ModalPrimaryButton text="Add" onClick={ onClick } dataPoint="Add_Biller_Group_Button"/>
      </CustomModalFooter>
    </CustomModal>
  );
}